<template>
  <el-dialog title="Datei hochladen" :visible="show" @close="close"
    width="30%"
  >
    <div class="row">
      <div class="col-sm-12">
        <form @submit.prevent="submit">
          <div class="form-group has-label">
            <label>Datei</label>
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="customFile"
                @change="fileSelected"
                @click="event => { event.target.value = null }"
              >
              <label class="custom-file-label" for="customFile">{{ file.file ? file.file.name : 'Datei auswählen' }}</label>
            </div>
            <div class="text-danger invalid-feedback" style="display: block;"
              v-if="valErrors['file']"
            >
              {{ valErrors['file'][0] }}
            </div>
          </div>
          <div class="form-group has-label">
            <label>Datum</label>
            <el-date-picker v-model="file.date" type="date"
              format="dd.MM.yyyy"
              value-format="yyyy-MM-dd"
              placeholder="Datum auswählen"
              :picker-options="{ firstDayOfWeek: 1 }"
            />
            <div class="text-danger invalid-feedback" style="display: block;"
              v-if="valErrors['date']"
            >
              {{ valErrors['date'][0] }}
            </div>
          </div>
          <fg-input label="Kommentar">
            <textarea class="form-control" v-model="file.comment" rows="3"></textarea>
          </fg-input>
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-fill btn-primary"
              :disabled="! canSubmit"
            >
              Hochladen
            </button>
            <button class="btn btn-fill btn-default"
              @click.prevent="close"
            >
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog, DatePicker } from 'element-ui'
import moment from 'moment'

export default {
  props: ['show', 'valErrors'],
  components: { [DatePicker.name]: DatePicker, [Dialog.name]: Dialog },
  data () {
    return {
      file: {
        file: null,
        date: this.setDefaultDate(),
        comment: ''
      }
    }
  },
  computed: {
    canSubmit () {
      return this.file.file && this.file.date
    }
  },
  methods: {
    fileSelected (event) {
      const files = event.target.files || event.dataTransfer.files
      if (!files.length) {
        this.file.file = null
      } else {
        this.file.file = files[0]
      }
    },
    submit () {
      const formData = new FormData()
      formData.append('file', this.file.file)
      formData.append('comment', this.file.comment)
      formData.append('date', this.file.date)
      this.$emit('submit', formData)
    },
    close () {
      this.file.date = this.setDefaultDate()
      this.file.comment = ''
      this.file.file = null
      this.$emit('close')
    },
    setDefaultDate () {
      return moment().format('YYYY-MM-DD')
    }
  }
}
</script>

<style>
</style>
